<template>
    <div class="BranchPageWarp">
        <NavMenu/>
        <!-- <div class="branchMenubox">
            <div class="leftarrowbox">
                <img :src="lefticon"  @click="leftFn" />
            </div>
            <div class="centerMenubox">
                <div class="textbox">
                    <div class="itemBox" ref="itemBox">
                        <div v-for="(item,index) in branchMenuList" :key="index" :class="currentName==item.name?'activebarnchmenu':'barnchmenu'" @click="clickBranchFn(item)">
                            {{item.name}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="rightarrowbox">
                <img :src="righticon"  @click="rightFn" />
            </div>
        </div> -->
        <div class="centerbox">
            <div class="itemBox" ref="itemBox">
                <div v-for="item in branchMenuList" :key="item.dictionariesId" :class="currentName==item.dictMsg?'activebarnchmenu':'barnchmenu'"
                    @click="clickBranchFn(item)">
                    {{item.dictMsg}}
                </div>
            </div>
            <div class="branchChildBox" v-if="branchMenuList.length!=0">
                <div v-if="currentName==branchMenuList[0].dictMsg">
                    <ChildPage1 :data='currentName' />
                </div>
                <div v-if="currentName==branchMenuList[1].dictMsg">
                    <ChildPage2 :data='currentName' />
                </div>
                <div v-if="currentName==branchMenuList[2].dictMsg">
                    <ChildPage3/>
                </div>
                <div v-if="currentName==branchMenuList[3].dictMsg">
                    <ChildPage4/>
                </div>
                <div v-if="currentName==branchMenuList[4].dictMsg">
                    <ChildPage5/>
                </div>
                <div v-if="currentName==branchMenuList[5].dictMsg">
                    <ChildPage6/>
                </div>
                <div v-if="currentName==branchMenuList[6].dictMsg">
                    <ChildPage7/>
                </div>
                <div v-if="currentName==branchMenuList[7].dictMsg">
                    <ChildPage8/>
                </div>
                <div v-if="currentName==branchMenuList[8].dictMsg">
                    <ChildPage9/>
                </div>
                <div v-if="currentName==branchMenuList[9].dictMsg">
                    <ChildPage10/>
                </div>

            </div>
        </div>
        <Footer/>
    </div>
</template>
<script>
import NavMenu from '@/components/navMenu.vue'
import Footer from '@/components/footer.vue'
import ChildPage1 from './componenets/childPage1'
import ChildPage2 from './componenets/childPage2'
import ChildPage3 from './componenets/childPage3'
import ChildPage4 from './componenets/childPage4'
import ChildPage5 from './componenets/childPage5'
import ChildPage6 from './componenets/childPage6'
import ChildPage7 from './componenets/childPage7'
import ChildPage8 from './componenets/childPage8'
import ChildPage9 from './componenets/childPage9'
import ChildPage10 from './componenets/childPage10'
import { httpService, srcUrl } from "@/service/httpService";
export default {
    components: {
        NavMenu,
        Footer,
        ChildPage1,
        ChildPage2,
        ChildPage3,
        ChildPage4,
        ChildPage5,
        ChildPage6,
        ChildPage7,
        ChildPage8,
        ChildPage9,
        ChildPage10
    },
    data() {
        return {
            srcUrl: srcUrl,
            // activatelefticon: require("@/assets/imgs/branch/activatelefticon.png"),
            // activaterighticon: require("@/assets/imgs/branch/activaterighticon.png"),
            lefticon: require("@/assets/imgs/branch/lefticon.png"),
            righticon: require("@/assets/imgs/branch/activaterighticon.png"),
            currentName: '',
            branchMenuList: [
                // { name: '国家机关人才交流机构分会' },
                // { name: '汽车人力资源分会' },
                // { name: '高级人才寻访专委会' },
                // { name: '航天人才分会' },
                // { name: '人力资源服务产业园区专委会' },
                // { name: '人力资源外包服务专委会' },
                // { name: '省级人力资源服务行业协会联席会' },
                // { name: '人才测评服务专委会' },
                // { name: '人力资源服务业数字化研究工作委员会' },
                // { name: '人力资源培训专业委员会' },
            ]
        }
    },
    mounted() {
        this.getlist()

    },
    methods: {
        getlist() {
            httpService.dataDictionary({ params: { fieldName: 'branchRegion' } }).then(res => {
                //  console.log(res,'分支机构');
                if (res.code == 200) {
                    this.branchMenuList = res.result
                    this.currentName = res.result[0].dictMsg
                }
            })
        },
        leftFn() {
            let itemBox = this.$refs.itemBox;
            if (itemBox.style.transform) {
                let number = itemBox.style.transform.split("(")[1].split("p")[0] * 1;
                if (number < 0) {
                    itemBox.style.transform = `translateX(${262 + number}px)`;
                } else {
                    this.righticon = require("@/assets/imgs/branch/activaterighticon.png");
                    this.lefticon = require("@/assets/imgs/branch/lefticon.png")
                    return false;
                }
            } else {
                return false;
            }
        },
        rightFn() {
            let itemBox = this.$refs.itemBox;
            if (itemBox.style.transform) {
                let number = itemBox.style.transform.split("(")[1].split("p")[0] * 1;
                if (-((this.branchMenuList.length - 5.5) * 262) >= number) {
                    this.righticon = require("@/assets/imgs/branch/righticon.png");
                    this.lefticon = require("@/assets/imgs/branch/activatelefticon.png")
                    return false;
                } else {
                    itemBox.style.transform = `translateX(${-262 + number}px)`;
                }
            } else {
                itemBox.style.transform = `translateX(-262px)`;
            }
        },
        clickBranchFn(item) {
            this.currentName = item.dictMsg
        }
    },
    filters: {
        timer: (value) => {
            return value.substring(0, 10);
        },
    },
}
</script>
<style lang="less" scoped>
.BranchPageWarp {
	width: 100%;
	margin: 0 auto;
	// .branchMenubox {
	// 	display: flex;
	// 	flex-direction: row;
	// 	width: 1500px;
	// 	margin: 40px auto 10px auto;
	// 	align-items: center;
	// 	justify-content: center;
	// 	.leftarrowbox,
	// 	.rightarrowbox {
	// 		width: 34px;
	// 		height: 34px;
	// 	}
	// 	.centerMenubox {
	// 		width: 1340px;
	// 		margin: 0 16px;
	// 		background: linear-gradient(
	// 			90deg,
	// 			rgba(255, 255, 255, 0) 0%,
	// 			#ffffff 5%,
	// 			#ffffff 94%,
	// 			rgba(255, 255, 255, 0.33) 100%
	// 		);
	// 		box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.1);

	// 		box-sizing: border-box;
	// 		.textbox {
	// 			width: 1300px;
	// 			margin: 0 auto;
	// 			overflow: hidden;
	// 		}
	// 		.itemBox {
	// 			width: 3500px;
	// 			height: 66px;
	// 			transition: all 0.8s;
	// 			display: flex;
	// 			flex-direction: row;
	// 			align-items: center;

	// 			.barnchmenu {
	// 				color: #333333;
	// 				font-size: 20px;
	// 				// line-height: 35px;
	// 				padding: 0 12px;
	// 				border-right: 1px solid #c2c2c2;
	// 				&:last-child {
	// 					border-right: none;
	// 				}
	// 				cursor: pointer;
	// 				// width: 200px;
	// 			}
	// 			.activebarnchmenu {
	// 				font-size: 20px;
	// 				font-weight: bold;
	// 				color: #448df7;
	// 				padding: 0 12px;
	// 				border-right: 1px solid #c2c2c2;
	// 				cursor: pointer;
	// 			}
	// 		}
	// 	}
	// }
	.branchChildBox {
		width: 750px;
		margin: 0px 0 0 50px;
	}
	.centerbox {
		width: 1200px;
		margin: 58px auto 60px auto;
		display: flex;
		flex-direction: row;

		.itemBox {
			width: 420px;
			border: 1px solid #e3e3e3;
			padding: 10px 15px;
			box-sizing: border-box;
			.barnchmenu {
				color: #333333;
				font-size: 20px;
				// line-height: 35px;
				padding: 0 12px;
				height: 66px;
				line-height: 66px;
				cursor: pointer;
				// width: 200px;
			}
			.activebarnchmenu {
				font-size: 20px;
				color: #448df7;
				padding: 0 12px;
				cursor: pointer;
				background: linear-gradient(
					90deg,
					rgba(255, 255, 255, 0) 0%,
					#ffffff 5%,
					#ffffff 94%,
					rgba(255, 255, 255, 0.33) 100%
				);
				box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.1);
				opacity: 0.86;
				height: 66px;
				line-height: 66px;
			}
		}
	}
}
</style>


